import { render, staticRenderFns } from "./Compliance.vue?vue&type=template&id=5ab6bf00&scoped=true"
import script from "./Compliance.vue?vue&type=script&lang=js"
export * from "./Compliance.vue?vue&type=script&lang=js"
import style0 from "./Compliance.vue?vue&type=style&index=0&id=5ab6bf00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab6bf00",
  null
  
)

export default component.exports